// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VerificationCodeInput_main__VO521 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
}

.VerificationCodeInput_input__uWSS6 {
    width: 56px;
    height: 56px;
    border: 2px solid #CBD1D8;
    text-align: center;
    border-radius: 12px;
    font-size: 24px;
}

.VerificationCodeInput_input_active__5ffml {
    border: 2px solid #17a8b5;
}`, "",{"version":3,"sources":["webpack://./src/pages/login/components/VerificationCodeInput/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".main {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 60px;\n}\n\n.input {\n    width: 56px;\n    height: 56px;\n    border: 2px solid #CBD1D8;\n    text-align: center;\n    border-radius: 12px;\n    font-size: 24px;\n}\n\n.input_active {\n    border: 2px solid #17a8b5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `VerificationCodeInput_main__VO521`,
	"input": `VerificationCodeInput_input__uWSS6`,
	"input_active": `VerificationCodeInput_input_active__5ffml`
};
export default ___CSS_LOADER_EXPORT___;
